module.exports = __webpack_public_path__ + "static/media/1.89ccd7a6.jpg";